import React from 'react';

const ChargerCard = ({ AddressInfo, NumberOfPoints, IsRecentlyVerified }) => {
  return (
    <li className={IsRecentlyVerified ? 'online' : 'offline'} >
      <p >
        Location: {AddressInfo.Title} <br />
        Address: {AddressInfo.AddressLine1} <br />
        Postcode: {AddressInfo.Postcode} <br />
          Number of chargers: {NumberOfPoints} <br />
        Online: {IsRecentlyVerified.toString()}
      </p>
    </li >
  );
};

export default ChargerCard; 